import MuiLink from '@mui/material/Link';

export const Link = MuiLink;
